module.exports = __webpack_public_path__ + "media/images/logo_sinoredi-d7b8f86330018fbedaf2d6b56797e99c.jpeg";